import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useSFX } from 'js/hooks/useSFX';

// import images
import placeholderImage from '../../../../images/static/collections_placeholder.jpg';

// import actions
import { deleteCollection } from 'js/store/collections/Collections.actions';

// import selectors
import { getCollectionById } from 'js/store/collections/Collections.selectors';
import { getCardById } from 'js/store/cards/Cards.selectors';
import { getTranslationById } from 'js/store/app/App.selectors';

// import components
import ButtonBasic from 'js/components/button/Button.basic';

const CollectionDelete = ({ collectionID, closeModal }) => {
  const siteText = {
    deleteButtonText: useSelector((state) => getTranslationById(state, 'overlay_popup_delete_button_text', 'Delete')),
    cancelButtonText: useSelector((state) => getTranslationById(state, 'overlay_popup_cancel_button_text', 'Cancel')),
    deleteThisGallery: useSelector((state) =>
      getTranslationById(state, 'overlay_popup_delete_this_gallery', 'Delete this gallery')
    ),
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { playSFX } = useSFX();

  const collection = useSelector((state) => getCollectionById(state, collectionID));
  const { cards = [] } = collection || {};
  const cardId = cards[0]?.id;
  const card = useSelector((state) => getCardById(state, cardId));

  const { largeImage = placeholderImage, title = collection?.name || '' } = card?.front || {};

  const triggerDeletion = () => {
    playSFX('deleted_item_alert');
    dispatch(deleteCollection(collection.id));
    closeModal();
    navigate('/library/');
  };

  return (
    <div className="collection-modal__delete">
      <h1>{siteText.deleteThisGallery}</h1>
      <figure style={{ width: 160, height: 160, margin: '20px auto', borderRadius: '20px', overflow: 'hidden' }}>
        <img src={largeImage} alt={title} className="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </figure>

      <h3 style={{ marginBottom: 40 }}>{collection?.name || ''}</h3>

      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
        <ButtonBasic title={siteText.cancelButtonText} action={closeModal} />
        <ButtonBasic
          title={siteText.deleteButtonText}
          action={triggerDeletion}
          style={{ backgroundColor: '#CF5F28' }}
        />
      </div>
    </div>
  );
};

export default CollectionDelete;
